import VirtualPortalPreregistrationClosed from './VirtualPortalPreregistrationClosed'

export default VirtualPortalPreregistrationClosed